import { useState } from 'react'

import { faTrophy } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { styled, css } from 'styled-components'

import { Colors, Typography } from '@b-stock/fe-core/design-system'

const BannerContainer = styled.div`
  position: relative;
`

const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: ${Colors.Semantic.BStock.onhover};
  color: ${Colors.Semantic.Neutral.white};
  border-radius: 0;
  padding: 0.625rem 1rem;
  cursor: default;
`

const BadgeRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  ${Typography.Body3}
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`

const Tooltip = styled.div<{ $visible: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 0.5rem);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 0.875rem;
  border-radius: 0.25rem;
  background: ${Colors.Semantic.Neutral.black};
  box-shadow: 0 0.1875rem 0.75rem rgba(0, 0, 0, 0.14);
  pointer-events: none;
  transition: opacity 150ms ease;

  ${({ $visible }) =>
    $visible
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
        `}
`

const TooltipTitle = styled.span`
  ${Typography.Body3}
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${Colors.Semantic.Neutral.white};
`

const TooltipBody = styled.span`
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.white};
`

/**
 * "First Dibs Listing" strip at the top of the bid action card. The caller
 * renders it only while the buyer's First Dibs window is open; the window
 * countdown lives in the page-level FirstDibsOpensBanner.
 */
const FirstDibsBanner = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false)

  return (
    <BannerContainer data-testid="first-dibs-banner">
      <HeaderBar
        tabIndex={0}
        aria-describedby="first-dibs-tooltip"
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
        onFocus={() => setTooltipVisible(true)}
        onBlur={() => setTooltipVisible(false)}
      >
        <BadgeRow>
          <FontAwesomeIcon icon={faTrophy} />
          <FormattedMessage id="Listing.firstDibsBanner.listingLabel" />
        </BadgeRow>
      </HeaderBar>

      <Tooltip id="first-dibs-tooltip" $visible={tooltipVisible} role="tooltip">
        <TooltipTitle>
          <FormattedMessage id="Listing.firstDibsBanner.tooltipTitle" />
        </TooltipTitle>
        <TooltipBody>
          <FormattedMessage id="Listing.firstDibsBanner.tooltipBody" />
        </TooltipBody>
      </Tooltip>
    </BannerContainer>
  )
}

export default FirstDibsBanner
